import useCustomMicrowebStepFunctions from 'src/microweb-step/useCustomMicrowebStepFunctions';
import { useAppSelector } from 'src/store/reducers';
import { getQueryParams } from 'src/util';
import { createReturnUrl } from 'src/util/redirectUtils';
import { redirectEtterFullfortSkjema } from 'src/util/veileder';

import type { RedirectParams } from 'src/types/url';

import { getFormData, getFormDefinition } from '@helsenorge/refero';

export const useRedirectVeilederData = () => {
  const formDefinition = useAppSelector(state => getFormDefinition(state));
  const formData = useAppSelector(state => getFormData(state));
  const documentGuid = useAppSelector(state => state.refero.ui.dokumentGuid);
  const harGuidanceAction = useAppSelector(state => state.refero.ui.harGuidanceAction);

  const isMicrowebStep = useAppSelector(state => state.microweb.isMicrowebStep);
  const isMicrowebOppgave = useAppSelector(state => state.microweb.isMicrowebOppgave);
  const { onCompleteMicroweb } = useCustomMicrowebStepFunctions();
  const queryParams = getQueryParams();
  const returnUrl = createReturnUrl(harGuidanceAction);
  const returUrl = useAppSelector(state => state.refero.ui.returUrl);

  const redirectParams: RedirectParams = {
    redirectUrl: queryParams?.get('redirect') ?? undefined,
    contextParameter: queryParams?.get('contextParameter') ?? undefined,
    documentGuid,
    returnUrl,
    taskId: queryParams?.get('taskId') ?? undefined,
  };

  return (normalRedirectFn: () => void): boolean => {
    return redirectEtterFullfortSkjema(
      formDefinition,
      formData,
      redirectParams,
      isMicrowebStep,
      isMicrowebOppgave,
      onCompleteMicroweb,
      normalRedirectFn,
      redirectParams.taskId,
      '',
      returUrl
    );
  };
};
